import React from 'react';
import { motion } from 'framer-motion';

const IntellectualProperty = () => {
  const videos = [
    {
      title: "¿Qué es la propiedad intelectual?",
      embedCode: "https://embed.wave.video/iwSE79yO1PiOYV7u",
      source: "Menéndez (2023b).",
      link: "https://www.tiktok.com/@alfredmenendez/video/7208605212347583750"
    },
    {
      title: "Categorías de la propiedad intelectual",
      embedCode: "https://embed.wave.video/Tsu368cABi7HBaji",
      source: "Menéndez (2023c).",
      link: "https://www.tiktok.com/@alfredmenendez/video/7211206089008811270"
    },
    {
      title: "«¿Puedo compartir eso?»: riesgos y regulaciones",
      embedCode: "https://embed.wave.video/AOxKtMO9Qhtniy8q",
      source: "Menéndez (2024).",
      link: "https://www.tiktok.com/@alfredmenendez/video/7339199426558233862"
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="max-w-4xl mx-auto px-4 py-12"
    >
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-purple-500 to-blue-500 bg-clip-text text-transparent mb-6">
          Propiedad intelectual
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-300">
          Comprende los fundamentos de la propiedad intelectual
        </p>
      </div>

      <div className="space-y-12">
        {videos.map((video, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-4 md:p-8"
          >
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 text-center">
              {video.title}
            </h2>

            <div className="flex justify-center mb-6">
              <div className="w-full max-w-sm">
                <div className="relative pb-[177.78%] h-0 overflow-hidden rounded-lg shadow-lg">
                  <iframe 
                    src={video.embedCode}
                    height="640" 
                    width="360" 
                    frameBorder="0" 
                    allow="autoplay; fullscreen" 
                    scrolling="no"
                    className="absolute top-0 left-0 w-full h-full"
                    style={{ aspectRatio: '9/16' }}
                  />
                </div>
              </div>
            </div>

            <div className="text-center">
              <p className="text-gray-600 dark:text-gray-400 text-sm">
                Fuente:{' '}
                <a
                  href={video.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-600 dark:text-indigo-400 hover:underline"
                >
                  {video.source}
                </a>
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default IntellectualProperty;